export default {
  label: {
    hot: '+ Quentes',
    new: '+ Novas',
    old: '+ Antigas',
    influence: '+ AAA',
    interactions: '+ Interações',
    shares: '+ Compartilhadas',
    likes: '+ Curtidas/Gostei',
    comments: '+ Comentadas',
  },
};
